module.exports = __webpack_public_path__ + "img/ecu_banner_en.128f12b4.jpg";